import apiClient from '../api/apiClient';

const REPORT_BASE = '/api/v1/admin/mtd-business-report';
const RECIPIENTS_BASE = '/api/v1/admin/report-email-recipients';

function unwrap(body) {
  if (body?.success === false) {
    const msg = body?.message;
    throw new Error(typeof msg === 'string' ? msg : 'Request failed');
  }
  return body?.data ?? body;
}

const mtdBusinessReportService = {
  getData: async (reportDate) => {
    const response = await apiClient.get(`${REPORT_BASE}/data`, {
      params: { report_date: reportDate },
    });
    return unwrap(response.data)?.report;
  },

  previewHtml: async (reportDate) => {
    const response = await apiClient.get(`${REPORT_BASE}/preview`, {
      params: { report_date: reportDate },
    });
    return unwrap(response.data);
  },

  sendReport: async ({ reportDate, emailTo }) => {
    const response = await apiClient.post(`${REPORT_BASE}/generate`, {
      report_date: reportDate,
      email_to: emailTo || undefined,
    });
    return unwrap(response.data);
  },

  listRecipients: async () => {
    const response = await apiClient.get(RECIPIENTS_BASE, {
      params: { report_type: 'mtd_business' },
    });
    return unwrap(response.data)?.recipients ?? [];
  },

  createRecipient: async (payload) => {
    const response = await apiClient.post(RECIPIENTS_BASE, {
      report_type: 'mtd_business',
      ...payload,
    });
    return response.data;
  },

  updateRecipient: async (uuid, payload) => {
    const response = await apiClient.patch(`${RECIPIENTS_BASE}/${uuid}`, payload);
    return response.data;
  },

  removeRecipient: async (uuid) => {
    const response = await apiClient.delete(`${RECIPIENTS_BASE}/${uuid}`);
    return response.data;
  },
};

export default mtdBusinessReportService;
